import { computed } from '@ember/object';
import { attr } from '@ember-data/model';
import ShModel from './sh-model';

const PAID_STATUS = {
  PAID: 'paid',
  UPCOMING: 'upcoming',
};

const PAID_STATUS_TEXT = {
  PAID: 'Paid',
  UPCOMING: 'Pending',
};

export const FREELANCER_PROJECT_METRIC = {
  PAID_STATUS,
  PAID_STATUS_TEXT,
};

const FreelancerProjectMetric = ShModel.extend({
  title: attr('string'),
  completedAt: attr('date'),
  amount: attr('number'),
  projectId: attr('string'),
  paymentId: attr('string'),
  buyerCompanyName: attr('string'),
  startedAt: attr('date'),
  paidAt: attr('date'),
  payoutAt: attr('date'),
  startDate: attr('date'),
  endDate: attr('date'),

  /**
   * @type {String}   of type FREELANCER_PROJECT_METRIC.PAID_STATUS.*
   */
  paidStatus: computed('paidAt', function() {
    if (this.get('paidAt')) {
      return FREELANCER_PROJECT_METRIC.PAID_STATUS.PAID;
    }

    return FREELANCER_PROJECT_METRIC.PAID_STATUS.UPCOMING;
  }),

  /**
   * Human readable string for the payment status of this metric.
   *
   * @type {String}
   */
  paidStatusText: computed('paidStatus', function() {
    switch (this.get('paidStatus')) {
      case FREELANCER_PROJECT_METRIC.PAID_STATUS.PAID:
        return FREELANCER_PROJECT_METRIC.PAID_STATUS_TEXT.PAID;
      case FREELANCER_PROJECT_METRIC.PAID_STATUS.UPCOMING:
        return FREELANCER_PROJECT_METRIC.PAID_STATUS_TEXT.UPCOMING;
    }

    return 'Unknown';
  }),
});

export default FreelancerProjectMetric;
